<template lang="pug">
    div
        // 卡片
        Card(dis-hover)
            Row(justify="space-between" align="middle")
                Col(v-if="!value.customDefaultCertApplyRule || value.customDefaultCertApplyRule === enumList.customDefaultCertApplyRule.FOLLOW_GROUP" :xs="24" :sm="24" :md="20" :lg="20")
                    h4(style="display: inline;") {{ $t("edgesetting.followGroup") }}
                    Poptip(:width="600" transfer)
                        Button(shape="circle" icon="md-help" size="small")
                        div(slot="title") {{ $t("edgesetting.explainFollowGroupTitle") }}
                        div(slot="content" style="max-height: 200px; overflow: scroll;")
                            p(style="word-break: break-word; white-space: normal;") {{ $t("edgesetting.explainFollowGroupText") }}
                            Table(:columns="tableColumn" :data="tableData")
                Col(v-else-if="value.customDefaultCertApplyRule === enumList.customDefaultCertApplyRule.EDGE_SPECIFIC" :xs="24" :sm="24" :md="20" :lg="20")
                    h4 {{ $t("edgesetting.edgeSpecific") }}
                    Row(align="middle")
                        Icon(type="md-contacts" style="padding: 5px;")
                        p {{ value.customDefaultCertGroup }}
                    Row(align="middle")
                        Icon(type="md-key" style="padding: 5px;")
                        p {{ value.customDefaultCertName }}
                Col(v-else-if="value.customDefaultCertApplyRule === enumList.customDefaultCertApplyRule.NONE" :xs="24" :sm="24" :md="20" :lg="20")
                    h4 {{ $t("edgesetting.none") }}
                Col(:xs="24" :sm="24" :md="4" :lg="4")
                    Button(@click="editCustomDefaultCert") {{$t('rcmtable.editText')}}
        // 彈出的視窗
        Modal(v-model="isModalShow" :title="$t('edgesetting.customDefaultCert')" :mask-closable="false")
            Form(ref="form" :model="form" :rules="rules" label-position="left" :label-width="100")
                FormItem(prop="selectedApplyRule" :label="$t('edgesetting.customDefaultCertApplyRule')")
                    Select(v-model="form.selectedApplyRule" :filterable="true")
                        Option(v-for="applyRule in applyRuleOptions" :value="applyRule.value" :key="applyRule.value") {{ applyRule.label }}
                template(v-if="form.selectedApplyRule === enumList.customDefaultCertApplyRule.EDGE_SPECIFIC")
                    FormItem(prop="selectedGroup" :label="$t('domainsetting.groupName')")
                        Select(v-model="form.selectedGroup" :filterable="true" @on-change="getCertOptions")
                            Option(v-for="group in groupOptions" :value="group.value" :key="group.value") {{ group.label }}
                    FormItem(prop="selectedCert" :label="$t('domainsetting.keypairname')")
                        Select(v-model="form.selectedCert" :filterable="true")
                            Option(v-for="cert in certOptions" :value="cert.value" :key="cert.value") {{ cert.label }}
            div(slot="footer")
                Button(@click="confirmEditCustomDefaultCert") {{$t('rcmtable.confirmText')}}
                Button(@click="cancelEditCustomDefaultCert") {{$t('rcmtable.cancelText')}}
</template>
<script>
import { getEsData } from "@/api/esdata";
import enumList from "@/libs/enumList";
import { getFormOptions } from "@/api/formoptions";

export default {
    name: "CustomDefaultCertSelector",
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        formData: {
            type: Object,
            default: () => ({}),
        },
        selectedItems: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            tableColumn: [
                { title: this.$i18n.t("domainsetting.groupName"), key: "groupName" },
                { title: this.$i18n.t("edgesetting.customDefaultCert"), key: "customDefaultCertName" },
            ],
            batchEditEdgeGroup: [],
            batchEditCertName: [],
            enumList,
            isModalShow: false,
            form: {
                selectedApplyRule: enumList.customDefaultCertApplyRule.FOLLOW_GROUP,
                selectedGroup: "",
                selectedCert: "",
            },
            rules: {
                selectedApplyRule: [],
                selectedGroup: [
                    {
                        required: true,
                        message: this.$i18n.t("rcmtable.required"),
                        trigger: "change",
                    },
                ],
                selectedCert: [
                    {
                        required: true,
                        message: this.$i18n.t("rcmtable.required"),
                        trigger: "change",
                    },
                ],
            },
            applyRuleOptions: [
                {
                    label: this.$i18n.t("edgesetting.followGroup"),
                    value: enumList.customDefaultCertApplyRule.FOLLOW_GROUP,
                },
                {
                    label: this.$i18n.t("edgesetting.edgeSpecific"),
                    value: enumList.customDefaultCertApplyRule.EDGE_SPECIFIC,
                },
                { label: this.$i18n.t("edgesetting.none"), value: enumList.customDefaultCertApplyRule.NONE },
            ],
            groupOptions: [],
            certOptions: [],
            groupCerts: [],
        };
    },
    methods: {
        async getFollowGroupCustomDefaultCertForBatchEdit() {
            if (!this.selectedItems.length) {
                this.batchEditEdgeGroup = [];
                this.batchEditCertName = [];
                return;
            }
            try {
                const isAdmin = this.$store.state.userData.privilege === "admin";
                const filters = [{ key: "nodeId", type: "string", value: this.selectedItems }];
                if (!isAdmin) {
                    filters.push({ key: "groupName", type: "string", value: this.formData.groupName });
                }
                const result = await getEsData({
                    esIndex: "rcm-edges",
                    searchView: "EdgeSetting",
                    filters,
                    sort: [],
                });
                const edges = result.data.mapData || [];
                // 取交集
                let groupNameIntersection = [...new Set(edges.flatMap((edge) => edge.groupName || []))];
                edges.forEach((edge) => {
                    const edgeGroupNames = new Set(edge.groupName || []);
                    groupNameIntersection = groupNameIntersection.filter((name) => edgeGroupNames.has(name));
                });
                this.batchEditEdgeGroup = groupNameIntersection;
                const groupCertMap = new Map();
                edges.forEach((edge) => {
                    (edge.followGroupCustomDefaultCert || []).forEach((entry) =>
                        groupCertMap.set(entry.groupName, entry)
                    );
                });
                this.batchEditCertName = this.batchEditEdgeGroup
                    .map((groupName) => groupCertMap.get(groupName))
                    .filter(Boolean);
            } catch (err) {
                this.batchEditEdgeGroup = [];
                this.batchEditCertName = [];
                console.error(err);
            }
        },
        async getGroupOptions() {
            let queryGroups = this.edgeGroups;
            if (this.$store.state.userData.privilege !== "admin") {
                const userGroups = this.$store.state.userData.inGroupsRole.map(({ groupName }) => groupName);
                queryGroups = this.edgeGroups.filter((edgeGroup) => userGroups.includes(edgeGroup));
            }
            if (!queryGroups.length) {
                this.groupOptions = [];
                return;
            }
            try {
                const queryParams = { groupNames: queryGroups.join(",") };
                const queryString = new URLSearchParams(queryParams).toString();
                const result = await getFormOptions(`/custom-default-cert-groups?${queryString}`);
                this.groupOptions = result.data.options.map((groupName) => ({
                    label: groupName,
                    value: groupName,
                }));
            } catch (err) {
                this.groupOptions = [];
                console.error(err);
            }
        },
        async getCertOptions() {
            const queryParams = { groupNames: this.form.selectedGroup };
            const queryString = new URLSearchParams(queryParams).toString();
            const result = await getFormOptions(`/custom-default-certs?${queryString}`);
            this.groupCerts = result.data.options;
            this.certOptions = this.groupCerts.map(({ customDefaultCertName }) => ({
                label: customDefaultCertName,
                value: customDefaultCertName,
            }));
        },
        async editCustomDefaultCert() {
            this.isModalShow = true;
            if (this.form.selectedGroup) {
                await this.getCertOptions();
            }
        },
        emitValue() {
            const isEdgeSpecific = this.form.selectedApplyRule === enumList.customDefaultCertApplyRule.EDGE_SPECIFIC;
            if (!isEdgeSpecific) {
                return this.$emit("input", {
                    customDefaultCertApplyRule: this.form.selectedApplyRule,
                });
            }
            const selectedItem = this.groupCerts.find(
                (option) =>
                    option.customDefaultCertGroup === this.form.selectedGroup &&
                    option.customDefaultCertName === this.form.selectedCert
            );
            if (!selectedItem) {
                return this.$emit("input", {
                    customDefaultCertApplyRule: enumList.customDefaultCertApplyRule.FOLLOW_GROUP,
                });
            }
            this.$emit("input", {
                ...selectedItem,
                customDefaultCertApplyRule: this.form.selectedApplyRule,
            });
        },
        confirmEditCustomDefaultCert() {
            this.$refs.form.validate((valid) => {
                if (!valid) return this.$Message.error(this.$t("rcmtable.formErrorMsg"));
                this.isModalShow = false;
                this.emitValue();
            });
        },
        cancelEditCustomDefaultCert() {
            this.isModalShow = false;
            this.$refs.form.resetFields();
        },
    },
    computed: {
        edgeGroups() {
            // 批次編輯
            if (this.selectedItems.length) return this.batchEditEdgeGroup;

            // 單筆編輯
            const { groupName } = this.formData;
            if (Array.isArray(groupName)) return groupName.filter(Boolean);
            return groupName ? [groupName] : [];
        },
        tableData() {
            // 單筆編輯取自 this.formData.followGroupCustomDefaultCert，批次編輯取自 this.batchEditCertName
            const entries = this.formData.followGroupCustomDefaultCert || this.batchEditCertName;
            if (this.$store.state.userData.privilege === "admin") return entries;
            const userGroups = this.$store.state.userData.inGroupsRole.map(({ groupName }) => groupName);
            return entries.filter((entry) => userGroups.includes(entry.groupName));
        },
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(val) {
                const mapping = {
                    customDefaultCertApplyRule: "selectedApplyRule",
                    customDefaultCertGroup: "selectedGroup",
                    customDefaultCertName: "selectedCert",
                };
                Object.keys(mapping).forEach((key) => {
                    if (val[key] !== undefined) {
                        this.form[mapping[key]] = val[key];
                    }
                });
            },
        },
        selectedItems: {
            immediate: true,
            handler() {
                if (!this.formData.followGroupCustomDefaultCert) {
                    this.getFollowGroupCustomDefaultCertForBatchEdit();
                }
            },
        },
        edgeGroups: {
            immediate: true,
            handler() {
                this.getGroupOptions();
            },
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/CustomDefaultCertSelector.vue